export const MEGABYTE: number = 1024 * 1024;

// Max number of share/lookup requests sent in parallel, to stay within
// Nextcloud's rate limits when sharing with many group chat members
export const SHARE_REQUEST_CHUNK_SIZE = 15;

// Max number of files uploaded at the same time, each chunked upload
// already runs its own sequence of chunk requests
export const PARALLEL_UPLOAD_LIMIT = 3;

// Max content widths, so pages don't stretch across wide tabs
export const LOGIN_FORM_MAX_WIDTH = 440;
export const WAITING_PANEL_MAX_WIDTH = 320;
